import { Dictionary } from '@/src/lib/dictionary/types';
import { StoreTenant } from '@/src/lib/store/types';
import { RegisterFormValidationModelPL } from '@/src/lib/validation/models/pl/register-form-validation.model';
import { RegisterFormValidationModelAU } from '@/src/lib/validation/models/au/register-form-validation.model';
import { RegisterFormValidationModelSE } from '@/src/lib/validation/models/se/register-form-validation.model';
import { RegisterFormValidationModelBE } from '@/src/lib/validation/models/be/register-form-validation.model';
import { RegisterFormValidationModelHU } from '@/src/lib/validation/models/hu/register-form-validation.model';
import { RegisterFormValidationModelNL } from '@/src/lib/validation/models/nl/register-form-validation.model';
import { RegisterFormValidationModelDE } from '@/src/lib/validation/models/de/register-form-validation.model';
import { RegisterFormValidationModelMX } from '@/src/lib/validation/models/mx/register-form-validation.model';
import { RegisterFormValidationModelAT } from '@/src/lib/validation/models/at/register-form-validation.model';
import { RegisterFormValidationModelFR } from '@/src/lib/validation/models/fr/register-form-validation.model';
import { RegisterFormValidationModelCZ } from '@/src/lib/validation/models/cz/register-form-validation.model';

export function getRegisterFormValidationRules(storeName: StoreTenant, dict: Dictionary) {
  if (!(storeName in StoreTenant)) {
    throw new Error(`Invalid store name '${storeName}'`);
  }

  const validationRules = {
    [StoreTenant.NL]: new RegisterFormValidationModelNL(dict),
    [StoreTenant.AU]: new RegisterFormValidationModelAU(dict),
    [StoreTenant.PL]: new RegisterFormValidationModelPL(dict),
    [StoreTenant.HU]: new RegisterFormValidationModelHU(dict),
    [StoreTenant.BE]: new RegisterFormValidationModelBE(dict),
    [StoreTenant.SE]: new RegisterFormValidationModelSE(dict),
    [StoreTenant.DE]: new RegisterFormValidationModelDE(dict),
    [StoreTenant.MX]: new RegisterFormValidationModelMX(dict),
    [StoreTenant.AT]: new RegisterFormValidationModelAT(dict),
    [StoreTenant.FR]: new RegisterFormValidationModelFR(dict),
    [StoreTenant.CZ]: new RegisterFormValidationModelCZ(dict),
};

  // eslint-disable-next-line security/detect-object-injection
  return validationRules[storeName].validate();
}
